import { render } from "./CustomScrollbar.vue?vue&type=template&id=50e4c937&scoped=true"
import script from "./CustomScrollbar.vue?vue&type=script&lang=js"
export * from "./CustomScrollbar.vue?vue&type=script&lang=js"

import "./CustomScrollbar.vue?vue&type=style&index=0&id=50e4c937&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e4c937"]])

export default __exports__